import { ReactElement } from "react";

import styles from "./index.module.css";
import { Drawing } from "../../../lib/drawing";

export default function AxisLabel(props: { axis: "x" | "y" }): ReactElement {
  const labels = [];
  switch (props.axis) {
    case "x":
      for (let i = 1; i <= Drawing.side; i++) {
        labels.push(<div key={i}>{i}</div>);
      }
      break;
    case "y":
      for (let i = Drawing.side; i > 0; i--) {
        labels.push(<div key={i}>{i}</div>);
      }
      break;
  }

  return (
    <div
      className={`${styles.label} ${props.axis === "x" ? styles.x : styles.y}`}
    >
      {labels}
    </div>
  );
}
